import { render } from "./formFooter.vue?vue&type=template&id=46725051&scoped=true"
import script from "./formFooter.vue?vue&type=script&lang=js"
export * from "./formFooter.vue?vue&type=script&lang=js"

import "@/assets/css/style_form_page.css?vue&type=style&index=0&id=46725051&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46725051"]])

export default __exports__